import Vue from 'vue';
import createApp from '@/app';
import { setupThirdPartyScripts } from '@/config/thirdParty';
Vue.use(require('vueperslides/dist/vueperslides.css'));
Vue.use(require('vue-slider-component/theme/default.css'));
Vue.config.productionTip = process.env.NODE_ENV === 'production';
// Third-party scripts (consent CMP, ads) are injected at runtime rather than
// sitting in public/index.html, so that a deployment can withhold them and a
// missing key means "do not load" instead of "load with a placeholder".
// Fire and forget: it never rejects. See docs/third-party-scripts.md.
setupThirdPartyScripts();
export const { app, router, store, apolloClient, legacyClient } = createApp();
app.$mount('#app');
